export const NAVBAR_MOBILE_HEIGHT = '56px';
export const NAVBAR_HEIGHT_STYLE = 'calc(100vh - var(--top-nav-height))';
